<!-- <app-example-wrapper-seamless sectionHeading="Dashboard"> -->
<div class="row">
    <div class="col-xl-12">
        <div class="card card-box mb-3">
            <div class="card-header">
                <div class="card-header--title">
                    <h3 class="font-size-lg mb-0 py-2 font-weight-bold">
                        Dashboard
                    </h3>
                </div>
                <div class="card-header--actions">
                    <div class="btn-group btn-group-sm" dropdown>
                        <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-primary" dropdownToggle
                            type="button">
                            {{filterSelection}}
                            <fa-icon [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1"></fa-icon>
                        </button>
                        <div *dropdownMenu class="dropdown-menu dropdown-menu-xl dropdown-menu-right">
                            <ul class="nav nav-neutral-dark nav-pills flex-column px-3">
                                <li class="nav-item nav-item--header px-0">
                                    <span class="text-capitalize text-black font-size-md font-weight-bold">Select
                                        Time Period</span>
                                </li>
                                <li class="dropdown-divider"></li>
                                <li class="nav-item">
                                    <a (click)='currentMonth()' class="nav-link">
                                        <span>Current Month</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a (click)='lastThreeMonths()' class="nav-link">
                                        <span>Last 3 months</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a (click)='lastSixMonths()' class="nav-link active">
                                        <span>Last 6 months</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <button tooltip="Refresh" (click)='currentMonth()'
                    class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                    type="button">
                    <span class="btn-wrapper--icon">
                        <i class="ion-md-sync"></i>
                    </span>
                </button>
            </div>
            <div class="card-body pb-1 font-weight-bold">
                <div class="row mb-2">
                    <div class="col-xl-3 col-md-6 col-sm-6">
                        <a [routerLink]="['/home/employees']" class="card card-box mb-2 text-white air-box-1">
                            <div class="card-body">
                                <div class="align-box-row align-items-start">
                                    <div class="font-weight-bold">
                                        <small class="text-white-70 d-block mb-1 text-uppercase">Employees</small>
                                        <span class="font-size-xxl mt-1">{{dashData!=null?dashData.users:''}}</span>
                                    </div>
                                    <div class="ml-auto">
                                        <i class="ion-md-person font-size-xxl"></i>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-xl-3 col-md-6 col-sm-6">
                        <a [routerLink]="" class="card  card-box mb-2 text-white air-box-2">
                            <div class="card-body">
                                <div class="align-box-row align-items-start">
                                    <div class="font-weight-bold">
                                        <small class="text-white-70 d-block mb-1 text-uppercase">Reservations</small>
                                        <span
                                            class="font-size-xxl mt-1">{{dashData!=null?dashData.reservationCount:''}}</span>
                                    </div>
                                    <div class="ml-auto">
                                        <i class="ion-md-calendar font-size-xxl"></i>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-xl-3 col-md-6 col-sm-6">
                        <a [routerLink]="" class="card  card-box mb-2 text-white air-box-3">
                            <div class="card-body">
                                <div class="no-gutters row">
                                    <div class="col-md-6 d-flex  flex-column">
                                        <div class="divider-v bg-light opacity-3 divider-v-lg mr-3 "></div>
                                        <div class="font-weight-bold">
                                            <small
                                                class="text-white-70 d-block mb-1 text-uppercase">Assigned&nbsp;&nbsp;</small>
                                            <span class="font-size-xxl mt-1">{{dashData!=null?dashData.assigned:''}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6 d-flex  flex-column">

                                        <div class="font-weight-bold">
                                            <small class="text-white-70 d-block mb-1 text-uppercase">UnAssigned
                                                &nbsp;&nbsp;</small>
                                            <span
                                                class="font-size-xxl mt-1">{{dashData!=null?dashData.unssigned:''}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-xl-3 col-md-6 col-sm-6">
                        <a [routerLink]="" class="card card-box mb-2 text-white air-box-4">
                            <div class="card-body">
                                <div class="align-box-row align-items-start">
                                    <div class="font-weight-bold">
                                        <small class="text-white-70 d-block mb-1 text-uppercase">Completed</small>
                                        <span class="font-size-xxl mt-1">{{dashData!=null?dashData.completed:''}}</span>
                                    </div>
                                    <div class="ml-auto">
                                        <img class="text-center text-white font-size-xl d-30"
                                            src="assets/img/completed.svg" />
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-xl-6">
        <div class="card card-box mb-3">
            <div class="card-header">
                <div class="card-header--title">
                    <h4 class="font-size-lg mb-0 font-weight-bold">
                        Greets Summary
                    </h4>
                </div>
                <div class="card-header--actions">
                    <div class="btn-group btn-group-sm" dropdown>
                        <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-primary" dropdownToggle
                            type="button">
                            {{filterSelection}}
                            <fa-icon [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1"></fa-icon>
                        </button>
                        <div *dropdownMenu class="dropdown-menu dropdown-menu-xl dropdown-menu-right">
                            <ul class="nav nav-neutral-dark nav-pills flex-column px-3">
                                <li class="nav-item nav-item--header px-0">
                                    <span class="text-capitalize text-black font-size-md font-weight-bold">Select
                                        Time Period</span>
                                </li>
                                <li class="dropdown-divider"></li>
                                <li class="nav-item">
                                    <a (click)='currentMonth()' class="nav-link">
                                        <span>Current Month</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a (click)='lastThreeMonths()' class="nav-link">
                                        <span>Last 3 months</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a (click)='lastSixMonths()' class="nav-link active">
                                        <span>Last 6 months</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <button tooltip="Refresh" (click)='currentMonth()'
                        class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                        type="button">
                        <span class="btn-wrapper--icon">
                            <i class="ion-md-sync"></i>
                        </span>
                    </button>
                </div>

            </div>
            <div class="card-body d-block px-2 py-3">
                <h6 *ngIf="pieChartData.length == 0">Loading..No Data..</h6>
                <div class="d-block" *ngIf="pieChartData.length>0">
                    <canvas baseChart [data]="pieChartData" [labels]="pieChartLabels" [colors]="pieChartColors"
                        [chartType]="pieChartType" [options]="pieChartOptions" [plugins]="pieChartPlugins"
                        [legend]="pieChartLegend" id="summaryPieChart">
                    </canvas>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box  mb-3">
            <div class="card-header">
                <div class="card-header--title">
                    <h4 class="font-size-lg mb-0 font-weight-bold">
                        Greets By Station
                    </h4>
                </div>
                <div class="card-header--actions">
                    <div class="btn-group btn-group-sm" dropdown>
                        <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-primary" dropdownToggle
                            type="button">
                            {{filterSelection}}
                            <fa-icon [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1"></fa-icon>
                        </button>
                        <div *dropdownMenu class="dropdown-menu dropdown-menu-xl dropdown-menu-right">
                            <ul class="nav nav-neutral-dark nav-pills flex-column px-3">
                                <li class="nav-item nav-item--header px-0">
                                    <span class="text-capitalize text-black font-size-md font-weight-bold">Select
                                        Time Period</span>
                                </li>
                                <li class="dropdown-divider"></li>
                                <li class="nav-item">
                                    <a (click)='currentMonth()' class="nav-link">
                                        <span>Current Month</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a (click)='lastThreeMonths()' class="nav-link">
                                        <span>Last 3 months</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a (click)='lastSixMonths()' class="nav-link active">
                                        <span>Last 6 months</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <button tooltip="Refresh" (click)='currentMonth()'
                        class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                        type="button">
                        <span class="btn-wrapper--icon">
                            <i class="ion-md-sync"></i>
                        </span>
                    </button>
                </div>
            </div>

            <div class="card-body d-block px-2 py-3">
                <div style="display: block" *ngIf="barChartData.length>0">
                    <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
                        [colors]="barChartColors" [legend]="barChartLegend" [plugins]="barChartPlugins"
                        [chartType]="barChartType">
                    </canvas>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-xl-6">
        <div class="card card-box  mb-3">
            <div class="card-header">
                <div class="card-header--title">
                    <h4 class="font-size-lg mb-0 font-weight-bold">
                        Upcoming Greets
                    </h4>
                </div>
                <div class="card-header--actions">
                    <button class="btn btn-sm btn-outline-primary mr-3" type="button"
                        (click)="reservationAssignedDetails()">
                        <span class="btn-wrapper--label">View details</span>
                        <span class="btn-wrapper--icon">
                            <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
                        </span>
                    </button>
                </div>
            </div>

            <div class="card-body d-block px-2 py-3">
                <div *ngIf="greetsLatest; let latest">
                    <div class="table-responsive">
                        <perfect-scrollbar [autoPropagation]="true" class="scroll-area mb-2">
                            <table class="table table-hover text-nowrap table-borderless mb-0">
                                <thead class="thead-light">
                                    <tr>
                                        <th scope="col">Res ID</th>
                                        <th scope="col">Retail Res ID</th>
                                        <th scope="col">Station</th>
                                        <th scope="col">Res Date</th>
                                        <th scope="col">Status</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr *ngFor="let g of greetsLatest let i=index;">
                                        <td>
                                            <a [routerLink]="['../greets/details', g.ResID,0]"
                                                class="font-weight-bold text-black" title="...">
                                                {{g.ResID}}
                                            </a>
                                        </td>
                                        <td>{{g?.LinkedResID}}</td>
                                        <td>{{g.AirportIATA}}</td>
                                        <td> <span class="">{{getUTCDate(g.start_time)}}</span>
                                        </td>
                                        <td>
                                            <span class="badge badge-danger" *ngIf="g.ResStatusID =='D'">
                                                Declined</span>
                                            <span class="badge badge-warning" *ngIf="g.ResStatusID =='U'">
                                                UnAssigned</span>
                                            <span class="badge badge-primary" *ngIf="g.ResStatusID =='A'">
                                                Assigned</span>
                                            <span class="badge badge-success" *ngIf="g.ResStatusID =='C'">
                                                Completed</span>
                                            <span class="badge badge-danger" *ngIf="g.ResStatusID =='W'">
                                                Waitlisted</span>
                                            <span class="badge badge-warning" *ngIf="g.ResStatusID =='RE'">
                                                Request Expired</span>
                                            <span class="badge badge-info" *ngIf="g.ResStatusID=='I'">
                                                In progress</span>
                                            <span class="badge badge-warning" *ngIf="g.ResStatusID =='OPEN'">
                                                Open</span>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </perfect-scrollbar>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box   mb-3">
            <div class="card-header text-left ">
                <div class="card-header--title font-weight-bold">
                    <h4 class="font-size-lg mb-0 font-weight-bold">
                        Cancelled Greets <span class="badge badge-pill badge-neutral-first"> Last 2 days
                            &nbsp;&nbsp;</span>
                    </h4>

                </div>
                <div class="card-header--actions">
                    <button class="btn btn-sm btn-outline-primary mr-3" type="button" (click)="reservationDetails()">
                        <span class="btn-wrapper--label">View details</span>
                        <span class="btn-wrapper--icon">
                            <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
                        </span>
                    </button>
                </div>
            </div>
            <div class="card-body d-block px-2 py-3">
                <div class="table-responsive">
                    <perfect-scrollbar [autoPropagation]="true" class="scroll-area scroll-area mb-2">
                        <table class="table table-hover text-nowrap table-borderless mb-0">
                            <thead class="thead-light">
                                <tr>
                                    <th scope="col">Res ID</th>
                                    <th scope="col">Retail Res ID</th>
                                    <th scope="col">Station</th>
                                    <th scope="col">Res Start Date</th>
                                    <th scope="col">Cancelled Date</th>
                                    <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let greet of canceledGreets'>
                                    <td> <a [routerLink]="['../bookings/edit-reservation', greet.ResID]"
                                            class="font-weight-bold text-black" title="...">
                                            {{greet?.ResID}}
                                        </a></td>
                                        <td>{{greet?.LinkedResID}}</td>
                                    <td>{{greet?.AirportIATA}}</td>
                                    <td>{{getUTCDate(greet.StartDT)}}</td>
                                    <td> {{getReservationCanceledDate(greet?.lastChangedDTUTC) | date:'MMM d, y HH:mm'}}
                                    </td>
                                    <td>
                                        <span class="badge badge-danger" *ngIf="greet.ResStatusID =='R'">
                                            Canx No Charge </span>
                                        <span class="badge badge-danger" *ngIf="greet.ResStatusID =='X'"> Canx
                                            Charge
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </perfect-scrollbar>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- </app-example-wrapper-seamless> -->